import { useLayoutEffect } from 'react';
import TagManager from 'react-gtm-module';

export const useGTM = () => {
  useLayoutEffect(() => {
    if (!(process.env['REACT_APP_ENV'] === 'production')) return;
    if (process.env['REACT_APP_GTM_ID']) {
      TagManager.initialize({ gtmId: process.env['REACT_APP_GTM_ID'] });
    }
  }, []);
};
